import { Component, input } from '@angular/core';
import { LinkDirective } from './link.directive';

export type LinkSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';

@Component({
  selector: 'a[joii-link]',
  hostDirectives: [
    {
      directive: LinkDirective,
      inputs: ['href', 'target', 'rel', 'disabled', 'download'],
    },
  ],
  template: `<ng-content />`,
  host: {
    '[attr.data-size]': 'size()',
    '[attr.data-color]': 'color()',
  },
  styleUrl: './link.component.css',
})
export class LinkComponent {
  /**
   * The size of the link.
   * @default '5'
   */
  readonly size = input<LinkSize>('5');
  readonly color = input<'default' | 'white'>('default');
}
